/* 🤖 this file was generated by svg-to-ts */
export const matIconAssistantPhoto: {
  name: 'assistant-photo';
  data: string;
} = {
  name: 'assistant-photo',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m12.36 6 .08.39.32 1.61H18v6h-3.36l-.08-.39-.32-1.61H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"/></svg>`
};
